import padStart from "lodash/padStart"

export const formatLength = (input) => {
  const strippedInput = input.replace(/[^\d:]/g, "")
  if (["", ":"].includes(strippedInput)) {
    return ""
  } else if (strippedInput.includes(":")) {
    return strippedInput
  } else {
    const inputSeconds = parseInt(strippedInput)
    return secondsToMinutesSeconds(inputSeconds)
  }
}

const secondsToMinutesSeconds = (inputSeconds) => {
  const minutes = Math.floor(inputSeconds / 60)
  const seconds = inputSeconds - minutes * 60
  const paddedSeconds = padStart(seconds, 2, "0")
  return [minutes, paddedSeconds].join(":")
}
